import { render, staticRenderFns } from "./Rating1To5QuestionConfig.vue?vue&type=template&id=40db7d76"
import script from "./Rating1To5QuestionConfig.vue?vue&type=script&lang=js"
export * from "./Rating1To5QuestionConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40db7d76')) {
      api.createRecord('40db7d76', component.options)
    } else {
      api.reload('40db7d76', component.options)
    }
    module.hot.accept("./Rating1To5QuestionConfig.vue?vue&type=template&id=40db7d76", function () {
      api.rerender('40db7d76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/QuestionConfig/Rating1To5QuestionConfig.vue"
export default component.exports